export default {
    state: () => ({
        data: {

        }
    }),
    mutations: {
        ['subResponseApplication/setState'](state, payload) {
            state.data = { ...payload }
        }
    }
}